import { render, staticRenderFns } from "./labelConfiguration.vue?vue&type=template&id=2f494b0a&scoped=true"
import script from "./labelConfiguration.vue?vue&type=script&lang=js"
export * from "./labelConfiguration.vue?vue&type=script&lang=js"
import style0 from "./labelConfiguration.vue?vue&type=style&index=0&id=2f494b0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f494b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f494b0a')) {
      api.createRecord('2f494b0a', component.options)
    } else {
      api.reload('2f494b0a', component.options)
    }
    module.hot.accept("./labelConfiguration.vue?vue&type=template&id=2f494b0a&scoped=true", function () {
      api.rerender('2f494b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/labelConfiguration.vue"
export default component.exports